import {
  defineComponent,
  getCurrentInstance,
  nextTick,
  onMounted,
  reactive,
  ref
} from '@vue/composition-api'
import _ from 'lodash'
import SurveyHeader from '../SurveyManagement/components/SurveyContent/components/SurveyHeader'
import Topic from '../SurveyManagement/components/SurveyContent/components/Topic'
import { PAGING_TOPIC_TYPE } from '../SurveyManagement/components/SurveyContent/config'
import { commitAnswerSurvey } from '../SurveyManagement/components/SurveyContent/topicCommonUtil'
import { answerSurveyService, submitSurveyHtmlService } from '@/services/survey'
import { useRequest } from '@/utils/bhooks'
import { getAnswerSurveyparams, getParentUrl, getSurveyHeight } from './util'
import VueI18n from 'vue-i18n'
import { getQueryString } from '@/utils/utils'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
NProgress.configure({
  showSpinner: false,
  minimum: 0.001
})
/** 正常问卷时，即不是一页一题的时候 */
const PAGE_TOPIC_TYPE = 15
const no_order = [5, 15] //当是分页和段落说明时不需要序号
const NormalSurvey = defineComponent({
  props: {
    surveyRule: {
      type: Array,
      default: () => []
    },
    surveyData: {
      type: Object,
      default: () => {}
    },
    surveyId: {
      type: String,
      default: ''
    },
    code: {
      type: String,
      default: ''
    },
    isTest: {
      type: Boolean,
      default: false
    },
    startTime: {
      type: String,
      default: ''
    },
    i18n: {
      type: VueI18n
    },
    createLanguageCode: {
      type: String,
      default: ''
    }
  },
  setup(props, context) {
    const { emit, refs } = context
    const preview = getQueryString('preview')
    const { state: answer, run: answerSurvey } = useRequest(answerSurveyService)
    const state = reactive({
      data: _.cloneDeep(props.surveyData),
      surveyRule: _.cloneDeep(props.surveyRule),
      renderTopics: [],
      lastPageTopic: {},
      pageIndex: 0,
      isAnswerInResult: false,
      isEnd: false,
      loading: false
    })
    let isEarly = ref('')
    let needEarly = ref(false)
    const submitLoading = ref(false)
    const instance = getCurrentInstance()
    const deletePageTopics = (data, isTrue) => {
      const len = data.topics.length
      data.topics = data.topics.filter((item, index) => {
        let flag = true
        if (
          (index === 0 && item.topicType == PAGING_TOPIC_TYPE) ||
          (index === data.topics.length - 1 &&
            item.topicType == PAGING_TOPIC_TYPE)
        ) {
          isTrue = true
          flag = false
        }
        return flag
      })

      if (len === data.topics.length) {
        isTrue = false
      }

      if (isTrue) {
        deletePageTopics(data, isTrue)
      }
      // return dataList
    }

    const sliceSurveyData = () => {
      let data = state.data
      //一头一尾的分页题剔除掉
      // data.topics = data.topics.filter((item, index) => {
      //   let flag = true
      //   if (
      //     (index === 0 && item.topicType == PAGING_TOPIC_TYPE) ||
      //     (index === data.topics.length - 1 &&
      //       item.topicType == PAGING_TOPIC_TYPE)
      //   ) {
      //     flag = false
      //   }
      //   return  flag
      // })
      deletePageTopics(data, false)

      //如果只有一题且是分页题直接剔除
      if (
        data.topics.length === 1 &&
        data.topics[0].topicType == PAGING_TOPIC_TYPE
      ) {
        data.topics = []
      }
      //如果分页题后面没有题需要删除掉
      let topics = data.topics || []
      while (topics[topics.length - 1]?.topicType == PAGE_TOPIC_TYPE) {
        topics.splice(topics.length - 1, 1)
      }
      //①需要判断内部是否有分页符,有分页符需要把数据切断；②判断是否有段落说明
      let renderTopics: any[] = []
      let someTopics = []
      let pageIndex = 0
      //当前分页的返回上一题由上一个分页题决定
      let toPageIndexList: number[] = []
      topics.forEach((element, index) => {
        if (element.topicType === PAGE_TOPIC_TYPE) {
          toPageIndexList.push(index)
        }
      })
      topics.forEach((item, index) => {
        if (item.topicSetting) {
          item.topicSetting.isCustomAllowNull = item.topicSetting.isAllowNull
        }
        if (item.topicType === PAGE_TOPIC_TYPE) {
          renderTopics.push(someTopics)
          if (pageIndex === 0) {
            //判断是不是第一个分页符，第一个分页符不能有回退键
            item.isFirstPage = true
          }
          //获取上一个分页数据
          if (toPageIndexList.includes(index)) {
            const cindex = toPageIndexList.indexOf(index)
            if (cindex !== 0) {
              const lastPageTopic = topics[toPageIndexList[cindex - 1]]
              if (lastPageTopic.topicSetting.isRollback) {
                item.isShowLastPage = true
              } else {
                item.isShowLastPage = false
              }
            }
          }
          renderTopics.push([item])
          someTopics = []
          state.lastPageTopic = item
          pageIndex++
        } else {
          someTopics.push(item)
          if (index === data.topics.length - 1) {
            renderTopics.push(someTopics)
          }
        }
      })
      state.renderTopics = renderTopics
    }

    const getPageIndexGap = (index, isReverse = false) => {
      let gap = 2
      if (isReverse) {
        for (let sindex = index - 1; sindex > 0; sindex--) {
          const sitem = state.renderTopics[sindex]
          //剔除分页
          if (!(sitem.length === 1 && sitem[0].topicType === PAGE_TOPIC_TYPE)) {
            //如果当前页的内容是全部影藏的则跳过当前页
            let hasDisplay = sitem.filter((v) => v.display)
            if (hasDisplay.length > 0) {
              break
            } else {
              gap += 2
            }
          }
        }
      } else {
        for (
          let sindex = index + 1;
          sindex < state.renderTopics.length;
          sindex++
        ) {
          const sitem = state.renderTopics[sindex]
          //剔除分页
          if (!(sitem.length === 1 && sitem[0].topicType === PAGE_TOPIC_TYPE)) {
            //如果当前页的内容是全部影藏的则跳过当前页
            let hasDisplay = sitem.filter((v) => v.display)
            if (hasDisplay.length > 0) {
              break
            } else {
              gap += 2
            }
          }
        }
      }
      return gap
    }

    const pageTopicClick = async (value) => {
      // 1: 上一页     (2: 下一页 3:结束答题) : 需要做验证
      switch (value) {
        case 1:
          //需要判断上一页的题是不是全都影藏
          const pageIndexGap = getPageIndexGap(state.pageIndex, true)
          state.pageIndex = state.pageIndex - pageIndexGap
          break
        case 2:
          if (commitAnswerSurvey(state.renderTopics[state.pageIndex])) {
            //判断下一页的题是不是全部影藏
            const pageIndexGap = getPageIndexGap(state.pageIndex)
            state.pageIndex = state.pageIndex + pageIndexGap
          }
          break
        default:
          if (commitAnswerSurvey(state.renderTopics[state.pageIndex])) {
            //获取当前最后一题的结束
            let topics = state.renderTopics[state.pageIndex]
            let endStr = topics[topics.length - 1]?.topicSetting.endword
            //获取当前分页的id
            const pageTopic = state.renderTopics[state.pageIndex + 1][0] || {}
            const params = getAnswerSurveyparams(topics, props, pageTopic?.id)
            logCommit()
            await answerSurvey(
              Object.assign({}, params, {
                preview: preview === '1' ? 1 : 0
              })
            )
            if (answer?.data?.code === 200) {
              emit('endAnswer', endStr)
            }
          }
          break
      }
      getSurveyHeightToOppoNet()
    }

    const answerTopic = (value, index, cindex) => {
      //答题时答案维护在源数据
      state.renderTopics[index]?.splice(cindex, 1, _.cloneDeep(value))
      //需要根据配置的问卷规则，对问卷源数据进行处理
      dealRenderTopics(value, false)
      renderProgress()
    }

    const renderProgress = () => {
      // 获取当前显示的题 并且有序号
      const showTopicList = state.renderTopics
        .flat(1)
        .filter((item) => item.display && item.order)
      // 获取有答案的题
      const answeredTopicList = showTopicList.filter((item) => {
        // 当是否有子题 即子题是否已经答题
        const isAnsweredSubTopic = !!item.matrixValue?.find((sitem) => {
          return Array.isArray(sitem.value)
            ? sitem.value.length
            : sitem.value || sitem.value == '0'
        })
        return (
          (item.value ||
            item.value == '0' ||
            item.values?.length ||
            isAnsweredSubTopic) &&
          !item.isShowTitleError &&
          !item.topicSetting?.isAllowNull
        )
      })
      const pre =
        answeredTopicList.length /
        showTopicList.filter((item) => !item?.topicSetting?.isAllowNull).length
      NProgress.set(pre > 0.9999 ? 0.999999 : pre)
    }

    const isContainArray = (plist, clist) => {
      let flag = true
      for (let index = 0; index < clist.length; index++) {
        const element = clist[index]
        if (!plist.includes(element)) {
          flag = false
          break
        }
      }
      return flag
    }
    const getTopicByTopicId = (topicId) => {
      let topic = {}
      let index = 0
      state.renderTopics.forEach((item) => {
        item.forEach((sitem) => {
          if (sitem.id === topicId) {
            topic = sitem
          }
        })
      })
      state.renderTopics.flat().forEach((item, sindex) => {
        if (item.id === topicId) {
          index = sindex
        }
      })
      return {
        topic,
        index
      }
    }

    const getMartinTopicByTopicId = (topicId) => {
      let topic = {}
      let index = 0
      state.renderTopics.flat().forEach((item: any, sindex) => {
        item?.matrixTopics?.forEach((sitem) => {
          if (sitem.id === topicId) {
            topic = item
            index = sindex
          }
        })
      })
      return {
        topic,
        index
      }
    }

    //判断是否存在逻辑冲突
    const isConflict = (item, value) => {
      if (item.hadDeal && item.display === !value && !value) {
        alert('逻辑冲突')
      }
    }

    const renderTargetTopics = (
      targetTopics,
      isShow,
      topicIndex,
      topicIndexList: any[] = [],
      surveyLogic,
      isAllTopic
    ) => {
      // topicIndexList //2.1版本加入topicIndexList参数，用于恢复逻辑是或并且被隐藏了的较大的index
      let renderTopics = state.renderTopics.flat()
      // console.log(targetTopics)
      for (let sindex = 0; sindex < targetTopics.length; sindex++) {
        const sitem = targetTopics[sindex]
        const targetOptionType = sitem.targetOptionType //2.跳转目标题 3.设置显示目标题 4.设置隐藏目标题 6.终止答题（计入结果）7.终止答题（不计入结果）
        let topicData = getTopicByTopicId(sitem.topicId)
        let stopic = topicData.topic
        //获取当前题的索引
        // console.log(sitem)
        let topicEndIndex = topicData.index
        switch (targetOptionType) {
          case 4: //隐藏
            // isConflict(stopic, isShow);
            stopic.display = isShow
            stopic.hadDeal = true
            break
          case 3: //显示
            // isConflict(stopic, isShow);
            stopic.display = !isShow
            stopic.hadDeal = true
            break
          case 8: // 必答切换
            if (!isAllTopic) {
              stopic.topicSetting.isAllowNull = stopic?.topicSetting
                ?.isCustomAllowNull
                ? isShow
                : !isShow
            }
            if (stopic.topicSetting.isAllowNull) {
              stopic.titleErrorTips = ''
            }
            stopic.hadDeal = true
            break
          case 2: //跳转
            //跳转就是从开始索引到结束索引之间的题全部影藏
            renderTopics.forEach((sitem, index) => {
              if (
                index >= topicIndexList[0] &&
                index < topicIndexList[topicIndexList.length - 1] &&
                surveyLogic === 1
              ) {
                sitem.display = true
              }
              if (
                index > topicIndex &&
                index < topicEndIndex &&
                sitem.topicType !== PAGING_TOPIC_TYPE
              ) {
                // isConflict(sitem, isShow);
                sitem.display = isShow
                sitem.hadDeal = true
              }
              if (index == topicEndIndex) {
                sitem.display = true
              }
            })
            break
          case 6:
            //终止答题(计入结果)
            //跳转就是从开始索引到结束索引之间的题全部影藏
            renderTopics.forEach((sitem, index) => {
              if (
                index >= topicIndexList[0] &&
                index < topicIndexList[topicIndexList.length - 1] &&
                surveyLogic === 1
              ) {
                sitem.display = true
              }
              if (index > topicIndex) {
                // isConflict(sitem, isShow);
                sitem.display = isShow
                sitem.hadDeal = true
              }
            })
            state.isAnswerInResult = true
            state.isEnd = !isShow
            isEarly.value = renderTopics[topicIndex]['topicSetting']['endword']
            if (isShow === false) {
              needEarly.value = true
            } else {
              needEarly.value = false
            }
            break
          default:
            //终止答题(不计入结果)
            //跳转就是从开始索引到结束索引之间的题全部影藏
            renderTopics.forEach((sitem, index) => {
              if (
                index >= topicIndexList[0] &&
                index < topicIndexList[topicIndexList.length - 1] &&
                surveyLogic === 1
              ) {
                sitem.display = true
              }
              if (index > topicIndex) {
                // isConflict(sitem, isShow);
                sitem.display = isShow
                sitem.hadDeal = true
              }
            })
            state.isAnswerInResult = false
            state.isEnd = !isShow
            isEarly.value = renderTopics[topicIndex]['topicSetting']['endword']
            if (isShow === false) {
              needEarly.value = true
            } else {
              needEarly.value = false
            }
            break
        }
      }
    }

    const dealTargetTopicPass = (inputArr) => {
      let lsArrJump: any[] = []
      let lsArrShowAndHidden: any[] = []
      let lsArrEnd: any[] = []
      for (let i = 0; i < inputArr.length; i++) {
        if (inputArr[i].targetOptionType == 2) {
          lsArrJump.push(inputArr[i])
        } else if ([6, 7].includes(inputArr[i].targetOptionType)) {
          lsArrEnd.push(inputArr[i])
        } else {
          lsArrShowAndHidden.push(inputArr[i])
        }
      }
      return [...lsArrShowAndHidden, ...lsArrJump, ...lsArrEnd]
    }

    const dealTargetTopicNotPass = (inputArr) => {
      let lsArrJump: any[] = []
      let lsArrShowAndHidden: any[] = []
      let lsArrEnd: any[] = []
      for (let i = 0; i < inputArr.length; i++) {
        if (inputArr[i].targetOptionType == 2) {
          lsArrJump.push(inputArr[i])
        } else if ([6, 7].includes(inputArr[i].targetOptionType)) {
          lsArrEnd.push(inputArr[i])
        } else {
          lsArrShowAndHidden.push(inputArr[i])
        }
      }
      return [...lsArrJump, ...lsArrEnd, ...lsArrShowAndHidden]
    }

    const isContainerAnyone = (clist, slist) => {
      let flag = false
      slist.forEach((item) => {
        if (clist.indexOf(item) !== -1) {
          flag = true
        }
      })
      return flag
    }

    const dealRenderTopics = (topic, isAllTopic) => {
      const optionType = [1, 2, 12, 3, 9]
      const scoreType = [8, 17]
      const martrinType = [3, 9, 14, 18]
      let filterRule = _.cloneDeep(state.surveyRule)
      let waitRenderListPass: any[] = [] //储存所有遍历好的题，等待渲染，不满足条件靠前，满足靠后
      let waitRenderListNotPass: any[] = [] //储存所有遍历好的题，等待渲染，不满足条件靠前，满足靠后
      for (let index = 0; index < filterRule.length; index++) {
        let topicIndex = getTopicByTopicId(topic.id).index
        const item = filterRule[index]
        let souceTopics = item.sourceTopics || []
        const targetTopics = item.targetTopics || []
        let isPass = true
        const topicIndexList: Array<number> = []
        for (let sindex = 0; sindex < souceTopics.length; sindex++) {
          //判断当前题是否存在逻辑设置
          const sitem = souceTopics[sindex]
          // console.log(sitem)
          topicIndexList.push(getTopicByTopicId(sitem.topicId).index)
          if (item.surveyLogic === 0) {
            //且

            //如果选择了任意一项、则直接continue
            if (sitem.sourceOptionSelectType === 2) {
              const lsTopic = getTopicByTopicId(
                sitem.topicId,
                state.renderTopics
              ).topic
              // console.log(lsTopic)
              if (
                !['', undefined, null].includes(lsTopic.value) ||
                lsTopic.values.length ||
                lsTopic.matrixValue.length
              ) {
                topicIndex = Math.max(...topicIndexList) //且逻辑，取大的
                continue
              } else {
                isPass = false
                topicIndex = Math.max(...topicIndexList) //且逻辑，取大的
                break
              }
            }
            //通过topicid找出对应的题的数据
            let topicData = [3, 9, 14, 18].includes(sitem.topicType)
              ? getMartinTopicByTopicId(sitem.topicId)
              : getTopicByTopicId(sitem.topicId)
            let stopic = topicData.topic
            if (optionType.includes(stopic.topicType)) {
              //比较topicOptionId

              //多选题特殊处理
              if (stopic.topicType === 2) {
                if (!isContainerAnyone(stopic.values, sitem.topicOptionId)) {
                  //满足条件
                  isPass = false
                  topicIndex = Math.max(...topicIndexList) //且逻辑，取大的
                  break
                }
              } else {
                if (
                  !sitem.topicOptionId.includes(stopic.value) &&
                  !isContainArray(stopic.values, sitem.topicOptionId)
                ) {
                  //满足条件
                  isPass = false
                  topicIndex = Math.max(...topicIndexList) //且逻辑，取大的
                  break
                }
              }
            } else if (scoreType.includes(stopic.topicType)) {
              if (!sitem.topicContent.includes(stopic.value.toString())) {
                isPass = false
                topicIndex = Math.max(...topicIndexList) //且逻辑，取大的
                break
              }
            } else if (martrinType.includes(stopic['topicType'])) {
              if (stopic['topicType'] === 9) {
                if (
                  !isContainerAnyone(
                    stopic?.['matrixValue']
                      ?.filter((item) => item.subTopicId === sitem.topicId)
                      ?.map((item) => item.value),
                    sitem.topicOptionId
                  )
                ) {
                  //满足条件
                  isPass = false
                  topicIndex = Math.max(...topicIndexList) //且逻辑，取大的
                  break
                }
              } else if (stopic['topicType'] === 3) {
                if (
                  !sitem.topicOptionId.includes(
                    stopic?.['matrixValue'].filter(
                      item.subTopicId === sitem.topicId
                    )?.[0]?.value
                  ) &&
                  !isContainerAnyone(
                    stopic?.['matrixValue']
                      ?.filter((item) => item.subTopicId === sitem.topicId)
                      ?.map((item) => item.value),
                    sitem.topicOptionId
                  )
                ) {
                  //满足条件
                  isPass = false
                  topicIndex = Math.max(...topicIndexList) //且逻辑，取大的
                  break
                }
              } else {
                if (
                  !sitem.topicContent.includes(
                    stopic?.['matrixValue']
                      ?.filter((item) => item.subTopicId === sitem.topicId)?.[0]
                      ?.value?.toString()
                  )
                ) {
                  isPass = false
                  topicIndex = Math.max(...topicIndexList) //且逻辑，取大的
                  break
                }
              }
            } else {
              //判断包含、不包含  1：包含、2：不包含
              if (sitem.textCondition === 1) {
                if (stopic.value?.indexOf(sitem.topicContent) === -1) {
                  isPass = false
                  topicIndex = Math.max(...topicIndexList) //且逻辑，取大的
                  break
                }
              } else {
                if (stopic.value?.indexOf(sitem.topicContent) !== -1) {
                  isPass = false
                  topicIndex = Math.max(...topicIndexList) //且逻辑，取大的
                  break
                }
              }
            }
            topicIndex = Math.max(...topicIndexList) //且逻辑，取大的
          } else {
            //或
            //如果选择了任意一项、则直接break
            if (sitem.sourceOptionSelectType === 2) {
              const lsTopic = getTopicByTopicId(
                sitem.topicId,
                state.renderTopics
              ).topic
              if (
                !['', null, undefined].includes(lsTopic?.value) ||
                lsTopic?.values?.length ||
                lsTopic?.matrixValue?.length
              ) {
                isPass = true
                topicIndex = getTopicByTopicId(sitem.topicId).index
                break
              } else {
                topicIndex = Math.min(...topicIndexList)
                continue
              }
            }
            //通过topicid找出对应的题的数据
            let topicData = getTopicByTopicId(sitem.topicId)
            let stopic = topicData.topic
            if (optionType.includes(stopic.topicType)) {
              //比较topicOptionId
              if (stopic.topicType === 2) {
                if (!isContainerAnyone(stopic.values, sitem.topicOptionId)) {
                  //满足条件
                  isPass = false
                  topicIndex = Math.min(...topicIndexList)
                } else {
                  isPass = true
                  topicIndex = getTopicByTopicId(sitem.topicId).index
                  break
                }
              } else {
                if (
                  !sitem.topicOptionId.includes(stopic.value) &&
                  !isContainArray(stopic.values, sitem.topicOptionId)
                ) {
                  //满足条件
                  isPass = false
                  topicIndex = Math.min(...topicIndexList)
                } else {
                  isPass = true
                  topicIndex = getTopicByTopicId(sitem.topicId).index
                  break
                }
              }
              if (
                !sitem.topicOptionId.includes(stopic.value) &&
                !isContainArray(stopic.values, sitem.topicOptionId)
              ) {
                //满足条件
                isPass = false
                topicIndex = Math.min(...topicIndexList)
              } else {
                isPass = true
                topicIndex = getTopicByTopicId(sitem.topicId).index
                break
              }
            } else if (scoreType.includes(stopic.topicType)) {
              // console.log(!sitem.topicContent.includes(stopic.value.toString()))
              if (!sitem.topicContent.includes(stopic.value.toString())) {
                isPass = false
                topicIndex = Math.min(...topicIndexList)
              } else {
                isPass = true
                topicIndex = getTopicByTopicId(sitem.topicId).index
                break
              }
            } else if (martrinType.includes(stopic['topicType'])) {
              if (stopic['topicType'] === 9) {
                if (
                  !isContainerAnyone(
                    stopic?.['matrixValue']
                      ?.filter((item) => item.subTopicId === sitem.topicId)
                      ?.map((item) => item.value),
                    sitem.topicOptionId
                  )
                ) {
                  //满足条件
                  isPass = false
                  topicIndex = Math.min(...topicIndexList)
                } else {
                  isPass = true
                  topicIndex = getTopicByTopicId(sitem.topicId).index
                  break
                }
              } else if (stopic['topicType'] === 3) {
                if (
                  !sitem.topicOptionId.includes(
                    stopic?.['matrixValue'].filter(
                      item.subTopicId === sitem.topicId
                    )?.[0]?.value
                  ) &&
                  !isContainerAnyone(
                    stopic?.['matrixValue']
                      ?.filter((item) => item.subTopicId === sitem.topicId)
                      ?.map((item) => item.value),
                    sitem.topicOptionId
                  )
                ) {
                  //满足条件
                  isPass = false
                  topicIndex = Math.min(...topicIndexList)
                } else {
                  isPass = true
                  topicIndex = getTopicByTopicId(sitem.topicId).index
                  break
                }
              } else {
                if (
                  !sitem.topicContent.includes(
                    stopic?.['matrixValue']
                      ?.filter((item) => item.subTopicId === sitem.topicId)?.[0]
                      ?.value?.toString()
                  )
                ) {
                  isPass = false
                  topicIndex = Math.min(...topicIndexList)
                } else {
                  isPass = true
                  topicIndex = getTopicByTopicId(sitem.topicId).index
                  break
                }
              }
            } else {
              //判断包含、不包含  1：包含、2：不包含
              if (sitem.textCondition === 1) {
                if (stopic.value?.indexOf(sitem.topicContent) === -1) {
                  isPass = false
                  topicIndex = Math.min(...topicIndexList)
                } else {
                  isPass = true
                  topicIndex = getTopicByTopicId(sitem.topicId).index
                  break
                }
              } else {
                if (stopic.value?.indexOf(sitem.topicContent) !== -1) {
                  isPass = false
                  topicIndex = Math.min(...topicIndexList)
                } else {
                  isPass = true
                  topicIndex = getTopicByTopicId(sitem.topicId).index
                  break
                }
              }
            }
          }
        }
        if (isPass) {
          //说明全部满足条件需要改变源数据
          waitRenderListPass.push([
            dealTargetTopicPass(targetTopics),
            false,
            topicIndex,
            souceTopics?.map((ele) => getTopicByTopicId(ele.topicId).index),
            item.surveyLogic
          ])
          //若已经有满足是提前结束的处理逻辑，结束遍历
          if (
            item.targetTopics.some((targetObj) =>
              [6, 7].includes(targetObj.targetOptionType)
            )
          ) {
            break
          }
        } else {
          waitRenderListNotPass.unshift([
            dealTargetTopicNotPass(targetTopics),
            true,
            topicIndex,
            souceTopics?.map((ele) => getTopicByTopicId(ele.topicId).index),
            item.surveyLogic
          ])
        }
      }
      if (isAllTopic) {
        //此处代码是刻意提升  ‘显示’逻辑的优先级
        waitRenderListNotPass.reverse()
      } else {
        let lsArr: any[] = []
        let lsArrJump: any[] = []
        let lsArrShowAndHidden: any[] = []
        let lsArrEnd: any[] = []
        for (let i = 0; i < waitRenderListNotPass.length; i++) {
          if (
            waitRenderListNotPass[i][0].filter(
              (item) => item.targetOptionType == 3
            ).length
          ) {
            lsArr.push(waitRenderListNotPass[i])
          } else {
            lsArr.unshift(waitRenderListNotPass[i])
          }
        }
        waitRenderListNotPass.reverse()
        for (let i = 0; i < waitRenderListPass.length; i++) {
          if (
            waitRenderListPass[i][0].filter(
              (item) => item.targetOptionType == 2
            ).length
          ) {
            lsArrJump.push(waitRenderListPass[i])
          } else if (
            waitRenderListPass[i][0].filter((item) =>
              [6, 7].includes(item.targetOptionType)
            ).length
          ) {
            lsArrEnd.push(waitRenderListPass[i])
          } else {
            lsArrShowAndHidden.push(waitRenderListPass[i])
          }
        }
        waitRenderListPass = [...lsArrShowAndHidden, ...lsArrJump, ...lsArrEnd]
      }
      let waitRenderList = [...waitRenderListNotPass, ...waitRenderListPass]
      waitRenderList.forEach((item) => {
        renderTargetTopics(
          item[0],
          item[1],
          item[2],
          item[3],
          item[4],
          isAllTopic
        )
      })
      //对题目序号进行二次处理，因为存在影藏题目的情况
      renderOrder()
    }

    onMounted(() => {
      sliceSurveyData()
      //默认执行一次
      state.renderTopics.flat().forEach((item) => {
        dealRenderTopics(item, true)
      })
    })

    const renderOrder = () => {
      let order = 0
      state.renderTopics.forEach((item) => {
        item.forEach((sitem) => {
          if (!no_order.includes(sitem.topicType) && sitem.display) {
            order++
            sitem.order = order
          }
          // 清除被隐藏的题目的答案
          if (!sitem['display']) {
            if (
              !['', null, undefined].includes(sitem.value) ||
              sitem.values.length
            ) {
              sitem.value = ''
              sitem.values = []
              dealRenderTopics(sitem, false)
            }
            if (sitem?.matrixValue.length) {
              // if(sitem?.matrixValue?.every?.(item=>!['',null,undefined].includes(item.value)))
              sitem.matrixValue.forEach((vItem) => {
                if (Array.isArray(vItem.value)) {
                  vItem.value = []
                } else {
                  vItem.value = null
                }
              })
            }
          }
        })
      })
      // console.log(state.renderTopics)
      instance?.proxy.$forceUpdate()
    }

    const logCommit = () => {
      // 上报html日志
      submitSurveyHtmlService({
        documentUri: window?.location?.href,
        htmlContent: document.getElementById('app')?.innerText
      })
    }

    const submitClick = _.throttle(async () => {
      let flag = commitAnswerSurvey(state.renderTopics[state.pageIndex])
      if (flag) {
        //表示可以提交
        const params = getAnswerSurveyparams(state.renderTopics.flat(), props)
        // console.log('接口开始调用...')
        // state.data.loading = true
        submitLoading.value = true
        logCommit()
        await answerSurvey(
          Object.assign({}, params, {
            preview: preview === '1' ? 1 : 0
          })
        )
        submitLoading.value = false
        state.data.loading = false
        if (answer?.data?.code === 200) {
          emit(
            'endAnswer',
            needEarly.value ? isEarly.value : state.data.surveyConfig.endword
          )
          //针对OPPO官网非一页一题
          nextTick(() => {
            if (window.parent !== window) {
              window?.parent?.postMessage(
                {
                  type: 'closeCemyunSurveyModal'
                },
                getParentUrl()
              )
            } else {
              window.CMYSurveyTools?.hideButton()
            }
            setTimeout(() => {
              // console.log('window.CEM_DESK_TOP_VAR', window.CEM_DESK_TOP_VAR);
              window.CEM_DESK_TOP_VAR &&
                window.CEM_DESK_TOP_VAR.callUserAnswered()
            }, 1500)
          })
        }
      }
    }, 5000)

    const getIsShowPage = (sindex) => {
      let isShowPage = false
      state.renderTopics.forEach((item, index) => {
        if (index > sindex && item[0].topicType !== PAGE_TOPIC_TYPE) {
          item.forEach((element) => {
            if (element.display) {
              isShowPage = true
            }
          })
        }
      })
      return isShowPage
    }

    const getIsShowNextPage = (sindex) => {
      const pageList = []
      state.renderTopics.forEach((item, index) => {
        if (
          index >= 0 &&
          index < sindex &&
          item[0].topicType == PAGE_TOPIC_TYPE
        ) {
          item.forEach((element) => {
            if (element.display) {
              pageList.push(element)
            }
          })
        }
      })
      return pageList.length > 0
    }

    const getSurveyHeightToOppoNet = () => {
      nextTick(() => {
        window?.parent?.postMessage(
          {
            type: 'cemyunSetHeight',
            height: getSurveyHeight(refs.surveyRef)
          },
          getParentUrl()
        )
      })
    }

    onMounted(() => {
      getSurveyHeightToOppoNet()
    })

    return () => {
      return (
        <div
          class="test-survey-content"
          v-loading={state.data.loading}
          ref="surveyRef">
          {state.pageIndex === 0 && (
            <div>
              {!['', undefined, null, 'empty', 'nobgColor'].includes(
                state.data.surveyConfig['backgroundImg']
              ) && (
                <div
                  class="survey-content-right-background"
                  style={{
                    backgroundImage: `url(${state.data.surveyConfig['backgroundImg']})`
                  }}></div>
              )}
              <SurveyHeader
                class="normal_header"
                noHover={true}
                item={state.data.surveyConfig}></SurveyHeader>
              {state.data.surveyConfig.aggrementPosition === 1 && (
                <div
                  class="padding024"
                  domPropsInnerHTML={state.data.surveyConfig.aggrement}></div>
              )}
            </div>
          )}

          {state.renderTopics.map((sitem, index) => {
            if (state.pageIndex === index) {
              if (index !== state.renderTopics.length - 1) {
                //判断是否是最后一页，最后一页不用展示分页符
                return (
                  <div>
                    {sitem.map((citem, cindex) => {
                      return citem.display ? (
                        <Topic
                          key={`part1${index}${cindex}`}
                          outerNet={true}
                          noHover={true}
                          i18n={props.i18n}
                          id={`topicId${citem.order}`}
                          onanswer={(value) =>
                            answerTopic(value, index, cindex)
                          }
                          item={citem}></Topic>
                      ) : (
                        ''
                      )
                    })}
                    {/* 分页题是否展示还需要对面后面的是否全部隐藏做匹配 */}
                    {getIsShowPage(state.pageIndex) &&
                      state.renderTopics[index + 1].map((citem, cindex) => {
                        //分页题
                        return citem.display ? (
                          <Topic
                            outerNet={true}
                            key={`part2${index}${cindex}`}
                            endBtnsWord={
                              state.data.surveyConfig.submitButtonText
                            }
                            onpageTopicClick={(value) => pageTopicClick(value)}
                            noHover={true}
                            id={`topicId${citem.order}`}
                            i18n={props.i18n}
                            onanswer={(value) =>
                              answerTopic(value, index, cindex)
                            }
                            item={citem}></Topic>
                        ) : (
                          ''
                        )
                      })}
                  </div>
                )
              } else {
                return sitem.map((citem, cindex) => {
                  return citem.display ? (
                    <Topic
                      outerNet={true}
                      key={`part3${index}${cindex}`}
                      id={`topicId${citem.order}`}
                      noHover={true}
                      i18n={props.i18n}
                      onanswer={(value) => answerTopic(value, index, cindex)}
                      item={citem}></Topic>
                  ) : (
                    ''
                  )
                })
              }
            } else {
              return ''
            }
          })}

          {(state.pageIndex === state.renderTopics.length - 1 ||
            !getIsShowPage(state.pageIndex)) &&
            !state.isEnd && (
              <div class="test-survey-footer">
                <div class="test-survey-footer-button-pack">
                  {state.lastPageTopic.topicSetting?.isRollback &&
                    getIsShowNextPage(state.pageIndex) && (
                      <el-button
                        type="success"
                        size="small"
                        onClick={() => pageTopicClick(1)}>
                        {state.lastPageTopic.topicSetting?.lastPageText}
                      </el-button>
                    )}
                  <el-button
                    type="success"
                    size="small"
                    loading={submitLoading.value}
                    disabled={state.renderTopics.length == 0}
                    onClick={() => submitClick()}>
                    {state.data.surveyConfig.submitButtonText}
                  </el-button>
                </div>
                {/* 当最后一个分页是可回退的时候，此处需要一个返回上一题按钮 */}
                {/* {props.isTest && <span>{props.i18n?.t('survy.isTest')}</span>} */}

                {state.data.surveyConfig.aggrementPosition === 0 && (
                  <div
                    class="padding24"
                    domPropsInnerHTML={state.data.surveyConfig.aggrement}></div>
                )}
              </div>
            )}

          {state.isEnd && (
            <div class="test-survey-footer">
              <div class="test-survey-footer-button-pack">
                <el-button
                  type="success"
                  size="small"
                  loading={submitLoading.value}
                  disabled={state.renderTopics.length == 0}
                  onClick={() => submitClick()}>
                  {state.data.surveyConfig.submitButtonText}
                </el-button>
              </div>
              {/* 当最后一个分页是可回退的时候，此处需要一个返回上一题按钮 */}
              {/* {props.isTest && <span>{props.i18n?.t('survy.isTest')}</span>} */}

              {state.data.surveyConfig.aggrementPosition === 0 && (
                <div
                  class="padding24"
                  domPropsInnerHTML={state.data.surveyConfig.aggrement}></div>
              )}
            </div>
          )}
        </div>
      )
    }
  }
})

export default NormalSurvey
